import React from "react";
import { VideoElementRefProvider } from "../VideoElementRefContext";
import PropTypes from "prop-types";

export const CoreFeatureStack = ({
  DataProviderComponent,
  uuid,
  video,
  videoStartId,
  isSandbox,
  config,
  orcaRef,
  children
}) => {
  return (
    <VideoElementRefProvider>
      {/* Render the provided data provider depending on which one we need */}
      <DataProviderComponent
        {...{
          uuid,
          video,
          videoStartId,
          isSandbox,
          config,
          orcaRef
        }}
      >
        {children}
      </DataProviderComponent>
    </VideoElementRefProvider>
  );
};

CoreFeatureStack.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.object,
  DataProviderComponent: PropTypes.elementType.isRequired,
  uuid: PropTypes.string.isRequired,
  video: PropTypes.object,
  videoStartId: PropTypes.string,
  isSandbox: PropTypes.bool,
  orcaRef: PropTypes.object
};
